// components/AppointmentDetails.js
import React from 'react';
import '../styles/AppointmentDetails.css';
import AppointmentTypeSelector from './AppointmentTypeSelector';

const AppointmentDetails = () => {
  return (
    <div className="appointment-details">
      <AppointmentTypeSelector />
      
    </div>
  );
};

export default AppointmentDetails;
